import { all_routes } from "../router/all_routes";

export const slugifyPackageText = (value: string) =>
  String(value || "")
    .toLowerCase()
    .trim()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const buildPackageSlug = (packageData: any) => {
  const pickup = packageData?.pickup_location?.name || packageData?.pickupLocation || "";
  const drop = packageData?.drop_location?.name || packageData?.dropLocation || "";
  const vehicle = packageData?.vehicle_detail?.name || packageData?.vehicleName || packageData?.name || "";
  const route = [pickup, drop].filter(Boolean).join(" to ");
  const baseSlug = slugifyPackageText([route, vehicle].filter(Boolean).join(" "));

  return baseSlug || packageData?.id || "";
};

export const getPackageSlug = (packageData: any) => packageData?.slug || buildPackageSlug(packageData);

export const getPackageUrl = (packageData: any) => {
  const slug = getPackageSlug(packageData);

  return slug ? `${all_routes.listingdetails}/${slug}` : all_routes.listingdetails;
};
